import { render } from "./AllDepoMessages.vue?vue&type=template&id=11d12338"
import script from "./AllDepoMessages.vue?vue&type=script&lang=js"
export * from "./AllDepoMessages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__